import * as React from 'react';
import { Component } from 'react';
import { FileUploadService } from '../services/FileUploadService';
import './FileUpload.css';
import { LoaderComponent } from './Loader';

interface IProps {
    UploadUrl?: string,
    UploadAdditionalParams?: any,
    MaxFileCount?: number,
    FileTypes?: string,
    OnFileUploaded?: (result: any) => void,
    OnFileSelected?: (selectedFiles: File[]) => void
}

interface IState {
    SelectedFiles: File[],
    ShowWarning: boolean,
    WarningMessage: string
    LoaderVisible: boolean
}

export class FileUploadComponent extends Component<IProps, IState> {
    constructor(props) {
        super(props);

        this.state = {
            SelectedFiles: [],
            ShowWarning: false,
            WarningMessage: '',
            LoaderVisible: false
        }

        this.OnFileSelected = this.OnFileSelected.bind(this);
        this.OnUploadButtonClick = this.OnUploadButtonClick.bind(this);
        this.OnUploadSuccess = this.OnUploadSuccess.bind(this);
    }



    public render() {
        let files: JSX.Element[] = [];
        for (let f of this.state.SelectedFiles) {
            files.push((
                <div className="file-item" key={f.lastModified}>
                    <span className="file-name">{f.name}</span>
                    <span className="file-size">{f.size}b</span>
                    <span className="delete-btn" onClick={this.DeleteFile.bind(this, f)}>&nbsp;</span>
                </div>
            ));
        }
        return (
            <div className="file-upload-component">
                <div className="file-upload-input">
                    <LoaderComponent Visible={this.state.LoaderVisible} />
                    <input
                        type="file"
                        onChange={this.OnFileSelected}
                        multiple={
                            this.props.MaxFileCount ? (this.props.MaxFileCount > 1 ? true : false) : true
                        }
                        accept={this.props.FileTypes}
                    />
                    <br />
                    <br />
                    <br />
                    <br />
                    <span>Przeciągnij pliki tutaj</span><br />
                    <span>lub</span><br />
                    <a>wybierz z dysku</a>
                </div>
                <div className="images-list">
                    <div className="info">
                        <p>
                            {this.props.FileTypes ? ('Dozwolony rodzaj plików: ' + this.FileTypesToString(this.props.FileTypes as string)) : ''}
                            <br />
                            Maksymalny rozmiar plików: 5MB
                        </p>
                    </div>
                    {files}
                </div>
                <div className="footer">
                    {this.RenderUploadButton()}
                    {this.RenderWarning()}
                </div>
            </div>
        );
    }

    private FileTypesToString(fileTypes: string) {
        let result: string[] = [];
        let fileTypeArray = fileTypes.split(',');
        for (let type of fileTypeArray) {
            switch (type.trim()) {
                case 'image/jpeg':
                    result.push('jpg');
                    break;
                case 'image/png':
                    result.push('png');
                    break;
                case 'application/pdf':
                    result.push('pdf');
                    break;
                default:
                    break;
            }
        }
        return result.join(', ');
    }

    private RenderUploadButton() {
        if (this.state.SelectedFiles.length > 0) {
            return (
                <button className="std-primary-btn" onClick={this.OnUploadButtonClick}>Wgraj pliki</button>
            );
        } else {
            return null;
        }
    }

    private RenderWarning() {
        if (this.state.ShowWarning) {
            return (
                <div className="warning">
                    {this.state.WarningMessage}
                </div>
            );
        } else {
            return null;
        }
    }

    private OnFileSelected(evt) {
        if (this.props.MaxFileCount) {
            if (this.props.MaxFileCount < evt.target.files.length) {
                console.log('clear files');
                evt.target.value = null;
                this.setState({
                    ShowWarning: true,
                    WarningMessage: 'Maksymalna ilość plików: ' + this.props.MaxFileCount
                });
                return;
            } else {
                this.setState({
                    ShowWarning: false,
                });
            }
        }
        for (let f of evt.target.files) {
            if ((f.size / (1024 * 1024)) > 5) {
                console.log('clear files');
                evt.target.value = null;
                this.setState({
                    ShowWarning: true,
                    WarningMessage: 'Maksymalny rozmiar pliku: 5 MB'
                });
                return;
            }
        }
        
        let selectedFiles: File[] = [];
        for (let f of this.state.SelectedFiles) {
            selectedFiles.push(f);
        }
        for (let f of evt.target.files) {
            selectedFiles.push(f);
        }
        this.setState({
            SelectedFiles: selectedFiles
        });
        if (this.props.OnFileSelected) {
            this.props.OnFileSelected(selectedFiles);
        }
    }

    private OnUploadButtonClick(evt) {
        if (this.props.UploadUrl) {
            this.setState({
                LoaderVisible: true
            });
            let service = new FileUploadService();
            service.UploadFiles(
                this.props.UploadUrl,
                this.state.SelectedFiles,
                this.props.UploadAdditionalParams,
                this.OnUploadSuccess,
                this.OnUploadError);
        }
    }

    private OnUploadSuccess(result) {
        this.setState({
            LoaderVisible: false
        });
        if (this.props.OnFileUploaded) {
            this.props.OnFileUploaded(result);
        }
    }

    private OnUploadError(error) {
        this.setState({
            LoaderVisible: false
        });
        console.error(error);
    }

    private DeleteFile(file: File, evt) {
        let selectedFiles: File[] = [];
        for (let f of this.state.SelectedFiles) {
            if (file.name !== f.name) {
                selectedFiles.push(f);
            }
        }
        this.setState({
            SelectedFiles: selectedFiles
        });
    }
}


// WEBPACK FOOTER //
// ./src/controls/FileUpload.tsx